module.exports = "\r\n<ul>\r\n    <li ng-repeat=\"datapoint in datapointList\">\r\n        {{datapoint.description}}\r\n    </li>\r\n</ul>";